<template>
  <div class="main-container">
    <under-construction></under-construction>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>
